import VSlider from './VSlider'

VSlider.install = function install (Vue) {
  Vue.component(VSlider.name, VSlider)
}

export default VSlider



// WEBPACK FOOTER //
// ./src/components/VSlider/index.js